<template>
    <div>
        <my-header :activeMenu="'news-index'"></my-header>
        <div class="news_detail_banner">
            <img src="https://cdn.kuailework.com/images/officialWebsite/banner/news@2x.png"/>
        </div>
        <div class="act_detail">
            <div class="tags">
                <span @click='toNews'>{{categoryName}}</span>&nbsp;> 详情
            </div>
            <h1 class="newstitle">{{detail.title}}</h1>
            <div class="newsdes">
                {{categoryName}} &nbsp;&nbsp;来源：搜才官网
                &nbsp;&nbsp;日期：{{detail.releaseDate}}
            </div>
            <div class="newsdetailcon" id="newsdetailcon">
                <div v-html="detail.comments"></div>
            </div>
        </div>
        <my-footer></my-footer>
        <link-bar></link-bar>
    </div>
</template>

<script>
    import MyHeader from "@/components/common/myHeader";
    import MyFooter from "@/components/common/myFooter";
    import getData from "@/api/getData";
    import LinkBar from "../../components/linkBar";
    export default {
        name: "detail",
        components: {LinkBar, MyFooter, MyHeader},
        data(){
            return{
                detail: {},
                categoryName: ''
            }
        },
        created() {
            let query = this.$route.query
            this.id = query.id || ''
            this.categoryName = query.categoryName
            this.getDetail()
        },
        methods:{
            toNews(){
                this.$router.push({
                    name: 'news-index'
                })
            },
            getDetail() {
                getData.get('https://nocoapi.kuailework.com/api/v2/tables/mr0ixhr2uoa6v9t/records/' + this.id, {}).then(res => {
                    let comments = res.data.comments
                    comments = comments.replace(/\/upload\/images\//g,'https://mcdn.kuailework.com/upload/images/')
                    console.log(comments)
                    this.detail = res.data
                    this.detail.comments = comments
                })
            }
        }
    }
</script>

<style>
    .news_detail_banner{
        width: 100%;
        height: 450px;
        position: relative;
        overflow: hidden;
    }
    .news_detail_banner img{
        left: 50%;
        height: 450px;
        transform: translateX(-50%);
        position: absolute;
    }
    .act_detail {
        width: 960px;
        margin: 0 auto;
        position: relative;
        padding-bottom: 50px;
    }
    .tags {
        margin-top: 60px;
        border-bottom: 1px solid #ececec;
        padding-bottom: 20px;
        color: #666;
        font-size: 16px;
        text-align: left;
    }
    .tags span {
        color: #666;
        font-size: 16px;
        cursor: pointer;
    }
    .tags span:hover{
        color: #1478FF;
    }
    .newstitle {
        font-size: 32px;
        text-align: center;
        padding: 5px 0px;
        margin-top: 30px;
        line-height: 30px;
        color: #444;
    }

    .newsdes {
        background: #f0f1f2;
        font-size: 12px;
        margin-top: 30px;
        text-align: center;
        line-height: 30px;
        color: #666;
    }

    .newsdetailcon {
        font-size: 16px;
        line-height: 30px;
        color: #666;
        text-align: left;
    }

    .newsdetailcon img {
        margin: 10px;
        display: block;
        margin: 20px auto;
    }

    .newsdetailcon p {
        margin-top: 10px;
        text-indent: 2em;
        text-align: justify;
    }
</style>